(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sd-native-bundles"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sd-native-bundles')) {
    customElements.define('sd-native-bundles', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.variantSelect = this.querySelector('[data-bundle-variant]');
        this.choices = this.querySelector('[data-bundle-choices]');
        this.form = this.closest('form');
        if (!this.variantSelect || !this.choices || !this.form) return;
        this.controller = new AbortController();
        this.addEventListener('change', event => {
          if (event.target.matches('[data-bundle-radio]') && event.target.checked && !event.target.disabled) {
            this.variantSelect.value = event.target.value;
            this.variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
          } else if (event.target === this.variantSelect) {
            this.syncSelection(true);
          }
        }, { signal: this.controller.signal });
        this.syncSelection(false);
        this.setAttribute('data-ready', '');
        this.choices.hidden = false;
      }
      syncSelection(updateUrl) {
        const radios = Array.from(this.querySelectorAll('[data-bundle-radio]'));
        const selected = radios.find(radio => radio.value === this.variantSelect.value);
        if (!selected || selected.disabled) return;
        radios.forEach(radio => { radio.checked = radio === selected; });
        const button = this.form.querySelector('button[name="add"]');
        if (button && !button.classList.contains('loading')) {
          button.disabled = false;
          button.classList.remove('sold-out');
          button.removeAttribute('aria-disabled');
          const text = button.querySelector('.button-text');
          if (text && button.dataset.persistentText) {
            text.textContent = button.dataset.persistentText + (button.dataset.showPrice === 'true' ? ' - ' + selected.dataset.priceFormatted : '');
          }
        }
        if (updateUrl) {
          const url = new URL(window.location.href);
          if (url.pathname === this.dataset.productUrl) {
            url.searchParams.set('variant', selected.value);
            window.history.replaceState(window.history.state, '', url);
          }
          const variant = { id: Number(selected.value), title: selected.dataset.title, price: Number(selected.dataset.price), compare_at_price: Number(selected.dataset.comparePrice), available: true };
          this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant, sectionId: this.dataset.sectionId } }));
          this.dispatchEvent(new CustomEvent('simple-variant-picker:variantChange', { bubbles: true, detail: { variant } }));
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  if (!customElements.get('sd-bundle-countdown')) {
    customElements.define('sd-bundle-countdown', class extends HTMLElement {
      connectedCallback() {
        clearInterval(this.interval);
        const date = this.dataset.endsAt || '';
        const validDate = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:Z|[+-]\d{2}:\d{2})$/.test(date);
        this.endsAt = validDate ? Date.parse(date) : NaN;
        this.clock = this.querySelector('[data-bundle-clock]');
        if (this.updateClock()) this.interval = setInterval(() => this.updateClock(), 1000);
      }
      updateClock() {
        const seconds = Math.ceil((this.endsAt - Date.now()) / 1000);
        if (!this.clock || !Number.isFinite(seconds) || seconds <= 0) {
          this.hidden = true;
          clearInterval(this.interval);
          return false;
        }
        this.clock.textContent = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(value => String(value).padStart(2, '0')).join(':');
        this.hidden = false;
        return true;
      }
      disconnectedCallback() { clearInterval(this.interval); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
